import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import {
  InlineFilters,
  UnconvertedSendovers,
  UnsignedAgreements,
  useInlineFiltersContext
} from 'features/command-center';
import { INLINE_FILTERS_KEYS } from 'features/command-center/constants';
import { userHasRoles } from 'services/Authorization';
import { Roles } from 'UI/constants/roles';
import { nestTernary } from 'UI/utils';

export const FollowUpTasks = () => {
  const { filters: contextFilters } = useInlineFiltersContext();
  const [filters, setFilters] = useState({});
  const finalFilters = { ...filters, ...contextFilters };
  const handleFiltersChange = selectedFilters => {
    setFilters(selectedFilters);
  };

  const inlineFilters = userHasRoles([Roles.Leadership])
    ? ['recruiters', 'industries', 'specialties', 'subspecialties', 'tenures']
    : nestTernary(
        userHasRoles([Roles.RegionalDirector]),
        ['recruiters', 'industries', 'tenures'],
        []
      );

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <InlineFilters
          filters={inlineFilters}
          onFiltersChange={handleFiltersChange}
          persistenceKey={INLINE_FILTERS_KEYS.dominate.followUpTasks}
        />
      </Grid>

      <Grid item xs={12}>
        <UnconvertedSendovers filters={finalFilters} />
      </Grid>

      <Grid item xs={12}>
        <UnsignedAgreements filters={finalFilters} />
      </Grid>
    </Grid>
  );
};
